<template>
	<div class="brick">
		<div class="half_tbl_box">
			<div class="left_big_tbl">
				<div class="view_inner">
					<table class="view_tbl" border="0">
						<colgroup>
							<col style="width:130px;" />
							<col style="width:400px;" />
							<col style="width:190px;" />
							<col style="" />
						</colgroup>
						<tbody>
							<tr>
								<th>Code</th>
								<td colspan="3">
									<input type="text" v-model.trim="partner.code" class="tbl_int ssm2_int" ref="code" v-bind:readonly="mode == 'detail'" v-bind:disabled="mode == 'detail'" @blur="makePassword" />
									<input type="text" v-if="user.company_id != 'newjigu'" v-model.trim="partner.alt_code" :disabled="state_scope_read_only" class="tbl_int ssm2_int mgr_15" style="margin-left:5px;" placeholder="Alternative Code" />
									<span v-show="!initial_partner_type">
										<label class="mgr_10"><input type="radio" value="C" v-model="partner.partner_type" :disabled="state_scope_read_only" @change="addTabPages()" /> Customer</label>
										<label class="mgr_10"><input type="radio" value="V" v-model="partner.partner_type" :disabled="state_scope_read_only" @change="addTabPages()" /> Vendor</label>
										<label class="mgr_10"><input type="radio" value="B" v-model="partner.partner_type" :disabled="state_scope_read_only" @change="addTabPages()" /> Both</label>
									</span>
									<button v-if="mode == 'add'" v-bind:disabled="!partner.code" class="gray_bt" @click="checkDup()">Check Dup.</button>
									<button v-else-if="modifiable || user.memo_mgmt" class="gray_bt" @click="openModal('Memo')"><font :color="partner.memo ? 'red' : 'black'">Memo</font></button>
									<template v-if="mode == 'detail'">
										<input type="text" v-model.trim="search_partner_code" class="tbl_int ssm2_int" placeholder="Code to Search" @keypress.enter="findPartner()" />
										<a href="javascript:;" type="button" class="search_bt" @click="findPartner()">Search</a>
									</template>
								</td>
							</tr>
							<tr>
								<th>Name / Company</th>
								<td><input type="text" v-model.trim="partner.name" :disabled="state_scope_read_only" class="tbl_int" /></td>
								<th>
									<span style="float:left;"><button v-if="mode == 'add'" v-bind:disabled="!partner.name" class="gray_bt" @click="checkDupName()">Check Dup.</button></span>
									<div style="margin-top:5px;">Biz Type</div>
								</th>
								<td>
									<span class="int_type_no_border"><CodeSelect className="tbl_select" :codes="businessTypes" v-model="partner.business_type_code" :disabled="state_scope_read_only" @set-code="setBusinessType"/></span>
									<!-- <a v-if="partModifiable" href="javascript:;" class="gray_bt" @click="updateBusinessType()">Update</a> -->
									<!-- <em class="lt_text"> {{ partner.business_type_name }}</em> -->
								</td>
							</tr>
							<tr>
								<th>Full Name</th>
								<td><input type="text" v-model.trim="partner.full_name" :disabled="state_scope_read_only" class="tbl_int" /></td>
								<th>Grade</th>
								<td>
									<span class="int_type_no_border"><CodeSelect className="tbl_select" :codes="grades" v-model="partner.grade_code" :disabled="state_scope_read_only" @set-code="setGrade"/></span>
									<!-- <em class="lt_text"> {{ partner.grade_name }}</em> -->
								</td>
							</tr>
							<tr>
								<th>DBA</th>
								<td><input type="text" v-model.trim="partner.dba_name" :disabled="state_scope_read_only" class="tbl_int" /></td>
								<th><font color="red">Notice</font></th>
								<td><input type="text" v-model.trim="partner.notice" :disabled="state_scope_read_only" class="tbl_int" style="color:red;" /></td>
							</tr>
							<tr>
								<th>Description</th>
								<td colspan="3">
									<input type="text" v-model.trim="partner.description" :disabled="state_scope_read_only" class="tbl_int" />
									<!-- <a v-if="partModifiable" href="javascript:;" class="gray_bt" @click="updateDescription()">Update</a> -->
								</td>
							</tr>
							<tr>
								<th>Terms Conditions</th>
								<template v-if="user.company_id == 'beautyplus'">
									<td>
										<input type="checkbox" v-model.trim="partner.retail_terms_conditions" disabled /> <span v-if="partner.retail_terms_conditions_date">{{ partner.retail_terms_conditions_date | moment('MM-DD-YYYY HH:mm:ss') }}</span>
									</td>
									<td colspan="2">
										<label for="active_yn" style="margin-left:15px;"> <input type="checkbox" id="active_yn" v-model="partner.active_yn" :disabled="state_scope_read_only" true-value="Y" false-value="N" />Active</label>
										<label for="blocked" style="margin-left:15px;"> <input type="checkbox" id="blocked" v-model="partner.blocked" :disabled="state_scope_read_only" @change="blockStatusChanged" />Blocked</label>
										<select v-model="partner.block_reason" class="tbl_select lm_int" :disabled="!partner.blocked || state_scope_read_only">
											<option v-for="reason in this.$partnerBlockReasons" v-bind:value="reason" v-bind:key="reason">{{ reason }}</option>
										</select>
									</td>
								</template>
								<template v-else>
									<td colspan="3">
										<input type="checkbox" v-model.trim="partner.retail_terms_conditions" disabled /> <span v-if="partner.retail_terms_conditions_date">{{ partner.retail_terms_conditions_date | moment('MM-DD-YYYY HH:mm:ss') }}</span>
										<label for="active_yn" style="margin-left:15px;"> <input type="checkbox" id="active_yn" v-model="partner.active_yn" :disabled="state_scope_read_only" true-value="Y" false-value="N" />Active</label>
										<label for="blocked" style="margin-left:15px;"> <input type="checkbox" id="blocked" v-model="partner.blocked" :disabled="state_scope_read_only" @change="blockStatusChanged" />Blocked</label>
										<select v-model="partner.block_reason" class="tbl_select lm_int" :disabled="!partner.blocked || state_scope_read_only">
											<option v-for="reason in this.$partnerBlockReasons" v-bind:value="reason" v-bind:key="reason">{{ reason }}</option>
										</select>
										<input type="text" v-model.trim="partner.other_block_reason" class="tbl_int lm_int" size="100" :disabled="partner.block_reason != 'OTHER' || state_scope_read_only" placeholder="Other reason" />
									</td>
								</template>
							</tr>

							<tr>
								<th>YTD Sales</th>
								<td colspan="3">
									<currency-input type="text" v-model.trim="partner.ytd" class="tbl_int ssm_int al_right" readonly />
									<span class="mgl_15"><b>Last Invoice Date</b></span>
									<input type="text" v-model.trim="partner.last_invoice_date" class="tbl_int ssm_int al_right" readonly />
									<span class="mgl_15"><b>Last Invoice Amount</b></span>
									<currency-input type="text" v-model.trim="partner.last_invoice_amount" class="tbl_int ssm_int al_right" readonly />
									<a href="javascript: void(0);" class="gray_bt" style="float:right;" @click="openModal('ShipToAddressManagement')">Ship To Addr. Management</a>
								</td>
							</tr>
							<tr>
								<td colspan="4">
									<!-- <h4 class="view_title_h4">{{ tabTitle }}</h4> -->
									<div class="tab_wrap w_16" style="padding-top:20px;padding-left:30px;padding-right:300px;">
										<ul>
											<li v-for="(tabPage, index) in tabPages" v-bind:key="index">
												<a href="javascript:;" @click="selectTab(index)" :class="{ on: currentTabPage == index }">{{ tabPages[index] }}</a>
											</li>
										</ul>
									</div>

									<!-- General Info -->
									<div v-show="currentTabPage == 0" :style="'height:' + tabHeight + 'px;'">
										<table class="view_tbl" border="0">
											<colgroup>
												<col style="width:140px;" />
												<col style="width:300px;" />
												<col style="width:130px;" />
												<col style="" />
											</colgroup>
											<tbody>
												<tr>
													<th>Owner Name</th>
													<td><input type="text" v-model.trim="partner.owner_name" :disabled="state_scope_read_only" class="tbl_int" /></td>
													<th>Owner Info</th>
													<td><input type="text" v-model.trim="partner.owner_info" :disabled="state_scope_read_only" class="tbl_int" /></td>
												</tr>
												<tr>
													<th>Tax ID</th>
													<td><input type="text" v-model.trim="partner.tax_id" :disabled="state_scope_read_only" class="tbl_int" /></td>
													<th>Business Hour</th>
													<td><input type="text" v-model.trim="partner.business_hour" :disabled="state_scope_read_only" class="tbl_int" /></td>
												</tr>
												<tr>
													<th>SSN</th>
													<td><input type="text" v-model.trim="partner.owner_ssn" :disabled="state_scope_read_only" class="tbl_int " /></td>
													<th>License No</th>
													<td><input type="text" v-model.trim="partner.owner_license_no" :disabled="state_scope_read_only" class="tbl_int " /></td>
												</tr>
												<tr>
													<th>Open / Entered Date</th>
													<td>
														<CustomDatePicker v-model="partner.open_date" :disabled="state_scope_read_only" />
													</td>
													<th>Specialty</th>
													<td>
														<input class="tbl_int" style="width:200px;" type="text" :value="'B-' + partner.bounce_count + '     R-' + partner.return_count + '     A-' + partner.average_paid_days" readonly />
													</td>
												</tr>
												<tr>
													<th>Race</th>
													<td>
														<span class="int_type_no_border"><CodeSelect className="tbl_select" :codes="races" v-model="partner.race_code" :disabled="state_scope_read_only" @set-code="setRace"/></span>
														<!-- <em class="lt_text"> {{ partner.race_name }}</em> -->
													</td>
													<th></th>
													<td>(* B : Bounce Count, R : Return Count, A : Average Paid Days)</td>
												</tr>
												<tr>
													<th style="padding-top:10px;">Address</th>
													<td style="padding-top:10px;" colspan="3">
														<input class="tbl_int" style="width:400px;" type="text" id="address_detail" v-model.trim="partner.address_detail" :disabled="state_scope_read_only" />
														<a v-if="!state_scope_read_only" href="javascript:;" class="gray_bt" @click="clearAddress()" style="margin-left:5px;">Clear</a>
														<span style="padding-left:15px;"><b>Territory</b></span>
														<span class="int_type_no_border"><CodeSelect className="tbl_select" :codes="territories" v-model="partner.territory_code" :disabled="state_scope_read_only" :showDesc="false" @set-code="setTerritory"/></span>
														<br />
														<input class="tbl_int" style="width:400px;" type="text" id="address_detail2" v-model.trim="partner.address_detail2" :disabled="state_scope_read_only" placeholder="Address Line 2 (Optional)" />
														<span style="padding-left:62px;"><b>Shipping Info.</b></span>
														<input class="tbl_int" style="width:200px;" type="text" v-model.trim="partner.ship_info" :disabled="state_scope_read_only" />
													</td>
												</tr>
												<tr>
													<th>City</th>
													<td colspan="3">
														<input type="text" class="tbl_int mm_int" placeholder="NEW YORK" v-model.trim="partner.address_city" :disabled="state_scope_read_only" />
														<input type="text" class="tbl_int sm_int" placeholder="NY" v-model.trim="partner.address_state" :disabled="state_scope_read_only" style="margin-left:5px;" />
														<input type="text" class="tbl_int ssm_int" placeholder="10029" v-model.trim="partner.address_zipcode" :disabled="state_scope_read_only" style="margin-left:5px;" @blur="makePassword" />
														<!-- <input type="text" class="tbl_int ssm_int" placeholder="US" v-model.trim="partner.country" style="margin-left:5px;" /> -->
														<span class="int_type_no_border mgr_10">
															<CodeSelect :width="100" :showDesc="false" :codes="countries" v-model.trim="partner.country" :disabled="state_scope_read_only" style="margin-left:5px;" />
														</span>
														<a href="#" class="gray_bt" id="map" type="button" style="margin-left:5px;" @click="openModal('GoogleMap')">Map</a>
														<a v-if="!state_scope_read_only" href="#" class="gray_bt" id="map" type="button" @click="confirmAddress()">Confirm Address</a>
													</td>
												</tr>
												<tr>
													<th>
														<template v-if="user.company_id == 'hairplus'">
															Store / Telephone / SMS
														</template>
														<template v-else>
															Telephone 1 / 2 / SMS
														</template>
													</th>
													<td colspan="3">
														<input type="text" v-model.trim="partner.telephone" :disabled="state_scope_read_only" class="tbl_int quarter_int" /> /
														<input type="text" v-model.trim="partner.telephone2" :disabled="state_scope_read_only" class="tbl_int quarter_int" /> /
														<input type="text" v-model.trim="partner.telephone_sms" :disabled="state_scope_read_only" class="tbl_int quarter_int" />
													</td>
												</tr>
												<tr>
													<th>Manager Name</th>
													<td>
														<input type="text" v-model.trim="partner.manager_name" :disabled="state_scope_read_only" class="tbl_int" />
													</td>
												</tr>
												<tr>
													<th>Manager Phone(s)</th>
													<td colspan="3">
														<input type="text" v-model.trim="partner.manager_telephone" :disabled="state_scope_read_only" class="tbl_int quarter_int" /> /
														<input type="text" v-model.trim="partner.manager_telephone2" :disabled="state_scope_read_only" class="tbl_int quarter_int" /> /
														<input type="text" v-model.trim="partner.manager_telephone3" :disabled="state_scope_read_only" class="tbl_int quarter_int" />
													</td>
												</tr>
												<tr>
													<th>
														<template v-if="user.company_id == 'hairplus'">
															Manager Email
														</template>
														<template v-else>
															Fax
														</template>
													</th>
													<td><input type="text" v-model.trim="partner.fax" :disabled="state_scope_read_only" class="tbl_int" /></td>
												</tr>
												<tr>
													<th>
														<template v-if="user.company_id == 'hairplus'">
															EMAIL 1 / ACCOUNT &amp; 2 / STORE
														</template>
														<template v-else>
															Email 1 / 2
														</template>
													</th>
													<td colspan="3">
														<input type="text" v-model.trim="partner.email" :disabled="state_scope_read_only" class="tbl_int quarter_int" /> /
														<input type="text" v-model.trim="partner.email2" :disabled="state_scope_read_only" class="tbl_int quarter_int" />
													</td>
												</tr>
												<tr>
													<th>Password</th>
													<td><input type="text" v-model.trim="partner.password" :disabled="state_scope_read_only" class="tbl_int" /></td>
												</tr>
											</tbody>
										</table>
									</div>

									<!-- Biz Process Info -->
									<div v-show="currentTabPage == 1" :style="'height:' + tabHeight + 'px;'">
										<table class="view_tbl" border="0">
											<colgroup>
												<col style="width:130px;" />
												<col />
											</colgroup>
											<tbody>
												<tr>
													<th>Delivery Type</th>
													<td>
														<span class="int_type_no_border"><CodeSelect className="tbl_select" :codes="deliveryTypes" v-model="partner.delivery_type_code" :disabled="state_scope_read_only" @set-code="setDeliveryType"/></span>
														<!-- <em class="lt_text"> {{ partner.delivery_type_name }}</em> -->
													</td>
												</tr>
												<tr>
													<th>Ship Charge</th>
													<td>
														<span class="int_type_no_border"><CodeSelect className="tbl_select" :codes="shipCharges" v-model="partner.ship_charge_code" :disabled="state_scope_read_only" @set-code="setShipCharge"/></span>
														<!-- <em class="lt_text"> {{ partner.ship_charge_name }}</em> -->
													</td>
												</tr>
												<tr>
													<th>Sales Group</th>
													<td>
														<span class="int_type_no_border"><CodeSelect className="tbl_select" :codes="salesGroups" v-model="partner.sales_group_code" :disabled="state_scope_read_only" @set-code="setSalesGroup"/></span>
														<!-- <em class="lt_text"> {{ partner.sales_group_name }}</em> -->
													</td>
												</tr>
												<tr>
													<th>Sales Man</th>
													<td>
														<span class="int_type_no_border"><CodeSelect className="tbl_select" :codes="reformattedSalesmans" v-model="partner.salesman_id" :disabled="state_scope_read_only" @set-code="setSalesman"/></span>
														<!-- <em class="lt_text"> {{ partner.sales_group_name }}</em> -->
													</td>
												</tr>
												<tr>
													<th>Monthly Credit Limit</th>
													<td><currency-input type="text" v-model.trim="partner.credit_limit" :disabled="state_scope_read_only" class="tbl_int ssm_int al_right" /></td>
												</tr>
												<tr>
													<th>Total Credit Limit</th>
													<td><currency-input type="text" v-model.trim="partner.total_credit_limit" :disabled="state_scope_read_only" class="tbl_int ssm_int al_right" /></td>
												</tr>
												<tr>
													<th></th>
													<td>
														<label for="cod_free_yn" style="margin-left:5px;"> <input type="checkbox" id="cod_free_yn" v-model="partner.cod_free_yn" :disabled="state_scope_read_only" true-value="Y" false-value="N" />COD Charge Free</label>
													</td>
												</tr>
												<tr>
													<th></th>
													<td>
														<label for="handling_charge_free_yn" style="margin-left:5px;">
															<input type="checkbox" id="handling_charge_free_yn" v-model="partner.handling_charge_free_yn" :disabled="state_scope_read_only" true-value="Y" false-value="N" />Handling Charge Free</label
														>
													</td>
												</tr>
												<tr>
													<th></th>
													<td>
														<label for="invoice_date_editable" style="margin-left:5px;"> <input type="checkbox" id="invoice_date_editable" v-model="partner.invoice_date_editable" :disabled="state_scope_read_only" />Invoice Date Editable</label>
													</td>
												</tr>
												<tr>
													<th></th>
													<td>
														<label for="show_credit" style="margin-left:5px;"> <input type="checkbox" id="show_credit" v-model="partner.show_credit" :disabled="state_scope_read_only" />Show Credit</label>
													</td>
												</tr>
											</tbody>
										</table>
									</div>

									<!-- Accounting Info -->
									<div v-show="currentTabPage == 2" :style="'height:' + tabHeight + 'px;'">
										<table class="view_tbl" border="0">
											<colgroup>
												<col style="width:130px;" />
												<col style="width:300px;" />
												<col style="width:130px;" />
												<col style="" />
											</colgroup>
											<tbody>
												<tr>
													<th>Bill To</th>
													<td colspan="3">
														<PartnerSelect v-model="partner.bill_to_code" :disabled="state_scope_read_only" :initialName="partner.bill_to_name" :activeOnly="true" ph="If different" />
														<!-- <span class="int_type_no_border"><CodeSelect className="tbl_select" :codes="paymentTerms" v-model="partner.payment_term_code" @set-code="setPaymentTerm"/></span> -->
														<!-- Select bill partner, if different -->
													</td>
												</tr>
												<tr>
													<th>Payment Term</th>
													<td colspan="2">
														<span class="int_type_no_border"><CodeSelect className="tbl_select" :codes="paymentTerms" v-model="partner.payment_term_code" :disabled="state_scope_read_only" @set-code="setPaymentTerm"/></span>
														<!-- <em class="lt_text"> {{ partner.payment_term_name }}</em> -->
													</td>
													<td></td>
												</tr>
												<tr>
													<th>Receipt Type</th>
													<td colspan="2">
														<span class="int_type_no_border"><CodeSelect className="tbl_select" :codes="recipetTypes" v-model="partner.receipt_type_code" :disabled="state_scope_read_only" @set-code="setReceiptType"/></span>
														<!-- <em class="lt_text"> {{ partner.receipt_type_name }}</em> -->
													</td>
												</tr>
												<tr>
													<th>A/R Type</th>
													<td colspan="2">
														<span class="int_type_no_border"><CodeSelect className="tbl_select" :codes="arTypes" v-model="partner.ar_type_code" :disabled="state_scope_read_only" @set-code="setArType"/></span>
														<!-- <em class="lt_text"> {{ partner.ar_type_name }}</em> -->
													</td>
												</tr>
												<tr>
													<th>Contact Person</th>
													<td><input type="text" v-model.trim="partner.attention_name" :disabled="state_scope_read_only" class="tbl_int" /></td>
												</tr>
												<tr>
													<th>Contact Phone</th>
													<td><input type="text" v-model.trim="partner.attention_phone" :disabled="state_scope_read_only" class="tbl_int" /></td>
												</tr>
												<tr>
													<th>Contact Address</th>
													<td><input type="text" v-model.trim="partner.attention_address" :disabled="state_scope_read_only" class="tbl_int" /></td>
												</tr>
												<tr>
													<th>Card Info</th>
													<td colspan="3"><input type="text" :title="partner.card_info" v-model.trim="partner.card_info" :disabled="state_scope_read_only" class="tbl_int" style="width:550px;" /></td>
												</tr>
												<tr>
													<th>Bank Info</th>
													<td colspan="3"><input type="text" :title="partner.bank_info" v-model.trim="partner.bank_info" :disabled="state_scope_read_only" class="tbl_int" style="width:550px;" /></td>
												</tr>
												<tr>
													<th>UPS Account Number</th>
													<td><input type="text" v-model.trim="partner.ups_account_number" :disabled="state_scope_read_only" class="tbl_int" /></td>
												</tr>
												<tr v-if="user.company_id == 'hairplus'">
													<th>UPS Ship Account</th>
													<td>
														<select v-model.number="partner.ups_shipper_seq" :disabled="state_scope_read_only" class="tbl_select">
															<option :value="null">Default (12DA40)</option>
															<option :value="2">Account #2 (22A7D1)</option>
														</select>
													</td>
												</tr>
											</tbody>
										</table>
									</div>

									<!-- Owner Info -->
									<div v-show="currentTabPage == 3" :style="'height:' + tabHeight + 'px;'">
										<table class="view_tbl" border="0">
											<colgroup>
												<col style="width:130px;" />
												<col style="width:300px;" />
												<col style="width:130px;" />
												<col style="" />
											</colgroup>
											<tbody>
												<tr>
													<th style="padding-top:10px;">Address</th>
													<td style="padding-top:10px;" colspan="3">
														<input class="tbl_int half_int" type="text" id="owner_address_detail" v-model.trim="partner.owner_address_detail" :disabled="state_scope_read_only" />
														<a v-if="!state_scope_read_only" href="javascript:;" class="gray_bt" @click="clearOwnerAddress()" style="margin-left:5px;">Clear</a>
													</td>
												</tr>
												<tr>
													<th>City</th>
													<td colspan="3">
														<input type="text" class="tbl_int mm_int" placeholder="NEW YORK" v-model.trim="partner.owner_address_city" :disabled="state_scope_read_only" />
														<input type="text" class="tbl_int sm_int" placeholder="NY" v-model.trim="partner.owner_address_state" :disabled="state_scope_read_only" style="margin-left:5px;" />
														<input type="text" class="tbl_int ssm_int" placeholder="10029" v-model.trim="partner.owner_address_zipcode" :disabled="state_scope_read_only" style="margin-left:5px;" />
														<!-- <input type="text" class="tbl_int ssm_int" placeholder="US" v-model.trim="partner.owner_country" style="margin-left:5px;" /> -->
														<span class="int_type_no_border">
															<CodeSelect :width="100" :showDesc="false" :codes="countries" v-model.trim="partner.owner_country" :disabled="state_scope_read_only" style="margin-left:5px;" />
														</span>
													</td>
												</tr>
												<tr>
													<th>Phone</th>
													<td><input type="text" v-model.trim="partner.owner_phone" :disabled="state_scope_read_only" class="tbl_int " /></td>
													<th></th>
													<td></td>
												</tr>
												<tr>
													<th>Cell Phone</th>
													<td><input type="text" v-model.trim="partner.owner_cell_phone" :disabled="state_scope_read_only" class="tbl_int " /></td>
												</tr>
												<tr>
													<th>Email</th>
													<td><input type="text" v-model.trim="partner.owner_email" :disabled="state_scope_read_only" class="tbl_int " /></td>
												</tr>
												<tr>
													<th>Date of Birth</th>
													<td><CustomDatePicker v-model="partner.owner_dob" :disabled="state_scope_read_only" /></td>
												</tr>
											</tbody>
										</table>
									</div>

									<div v-show="currentTabPage == 4" :style="'height:' + tabHeight + 'px;padding-left:50px;padding-right:220px;'">
										<div>
											<em class="lt_text">Doc Type</em>
											<span class="int_type_no_border"> <CodeSelect :codes="docTypes" v-model="doc_type_code" :disabled="state_scope_read_only" @set-code="setDocType" /> </span>
											<button v-if="modifiable" :disabled="mode == 'add' || !doc_type_code" @click="uploadFile">Upload</button>
											<input type="file" ref="uploadFile" class="file_input_hidden" @change="uploadFileConfirm()" />
										</div>
										<table id="item_list" class="list_tbl">
											<thead>
												<tr>
													<th style="text-align:center;width:25%;">Type</th>
													<th style="text-align:center;width:35%;">FileName</th>
													<th style="text-align:center;width:10%">FileSize</th>
													<th style="text-align:center;width:20%;">Modified Date</th>
													<th style="text-align:center;width:10%">Delete</th>
												</tr>
											</thead>

											<tbody>
												<tr v-for="doc in docs" v-bind:key="doc.doc_no">
													<td>{{ doc.doc_type_name }}</td>
													<td>
														<!-- #3406 : Restriction Only 보기(지정 State 조회 전용)에서는 문서를 내려받지 않는다. 이름만 보인다. -->
														<span v-if="state_scope_read_only">{{ doc.original_filename }}</span>
														<a v-else href="javascript:;" @click="downloadFile(doc)">{{ doc.original_filename }}</a>
													</td>
													<td style="text-align:right;">{{ doc.filesize | commaSeparated }}</td>
													<td>{{ doc.upd_dt ? doc_upd_dt : doc.crt_dt | moment('MM-DD-YYYY HH:mm:ss') }}</td>
													<td><button v-if="modifiable" @click="deleteFile(doc)">Delete</button></td>
												</tr>
											</tbody>
										</table>
									</div>

									<!-- Shopify Info -->
									<div v-show="currentTabPage == 5 && partner.partner_type !== 'V'" :style="'height:' + tabHeight + 'px;'">
										<table class="view_tbl" border="0">
											<colgroup>
												<col style="width:130px;" />
												<col style="width:350px;" />
												<col style="width:130px;" />
												<col style="" />
											</colgroup>
											<tbody v-if="mode === 'detail'">
												<tr>
													<th>Shop Name</th>
													<td>
														<span class="int_type_no_border">
															<select v-model="selected_third_party_store_no" class="tbl_select">
																<option v-for="(store, index) in third_party_store_list" :key="index" :value="store.store_no">{{ store.store_name }}</option>
															</select>
														</span>
													</td>
													<td></td>
													<td></td>
												</tr>
												<tr v-for="(id, index) in third_party_customer_ids" :key="index">
													<td></td>
													<td colspan="3">
														<span class="mgr_10">{{ id.program_customer_id }}</span>
														<a v-if="!state_scope_read_only" href="javascript:void(0);" @click="deleteThirdPartyCustomer(id.cust_no)" class="gray_bt">Del.</a>
													</td>
												</tr>
												<tr>
													<th style="padding-top: 10px;">New Cust.</th>
													<td style="padding-top: 10px;"><input type="text" class="tbl_int" v-model.trim="new_program_customer_id" :disabled="state_scope_read_only" placeholder="Input Excluding 'gid://shopify/Customer/' From Shopify ID." /></td>
													<td style="padding-top: 10px;"><a v-if="!state_scope_read_only" href="javascript:void(0);" @click="addThirdPartyCustomer()" class="gray_bt">Add</a></td>
													<td style="padding-top: 10px;"></td>
												</tr>
											</tbody>
											<tbody v-else>
												<tr>
													<td colspan="4" class="al_center">
														<b>Register Customer First.</b>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</td>
							</tr>
							<tr v-if="user.admin_yn == 'Y'">
								<td colspan="4">
									<span v-if="partner.crt_dt">Created : {{ partner.crt_dt | moment('MM-DD-YYYY HH:mm:ss') }} by {{ partner.crt_user }}</span>
									<span v-if="partner.upd_dt">, Last updated : {{ partner.upd_dt | moment('MM-DD-YYYY HH:mm:ss') }} by {{ partner.upd_user }}</span>
								</td>
							</tr>
							<tr v-else-if="!modifiable && partModifiable">
								<td colspan="4" class="al_right">Updatable Info. : Business Type, Description, Owner Info, Contact Information Except Telephone 1</td>
							</tr>
						</tbody>
					</table>

					<div class="view_bottom_bt">
						<!-- <a v-if="modifiable" href="javascript:;" type="button" class="search_bt" @click="submit(false)">Save & Return To Previous Page</a> -->
						<a v-if="modifiable" href="javascript:;" type="button" class="search_bt" @click="submit(false)">Save & Return To Previous Page</a>
						<a v-if="modifiable" href="javascript:;" type="button" class="search_bt" @click="submit(true)">Save Only</a>
						<a v-if="!modifiable && partModifiable" href="javascript:;" type="button" class="search_bt" @click="updatePart()">Save Part</a>
						<!-- <a href="javascript:;" type="button" :disabled="mode == 'add'" :class="mode == 'add' ? 'disable_bt' : 'gray_bt'" @click="delPartner()" class="delete_button">Delete</a> -->
						<a href="javascript:;" type="button" class="gray_bt mgl_15" @click="goBack">Cancel</a>
					</div>
				</div>
			</div>

			<div class="right_small_tbl">
				<div class="mgb_5">
					<h4 class="inner_h5">
						<a href="javascript:;" :style="'cursor:pointer;' + (historyTab == 'block' ? 'font-weight:bold;text-decoration:underline;' : 'color:#999;font-weight:normal;')" @click="historyTab = 'block'">Block History</a>
						<a
							v-if="user.company_id == 'beautyplus' && user.admin_yn == 'Y'"
							href="javascript:;"
							:style="'margin-left:15px;cursor:pointer;' + (historyTab == 'active' ? 'font-weight:bold;text-decoration:underline;' : 'color:#999;font-weight:normal;')"
							@click="historyTab = 'active'"
							>Active Status History</a
						>
					</h4>
					<div v-show="historyTab == 'block'" class="fixed-table-container" style="height: 235px; overflow-x: auto;">
						<!-- <div class="table-wrapper" style="height:410px;"> -->
						<div class="table-wrapper">
							<table id="item_list" class="list_tbl tbl_pointer" border="0">
								<thead>
									<tr>
										<th style="text-align:center;width:180px;"><div class="th-text">Date Time</div></th>
										<th style="text-align:center;width:180px;"><div class="th-text">Operator ID</div></th>
										<th style="text-align:center;"><div class="th-text">Block Reason / Unblock</div></th>
									</tr>
								</thead>

								<tbody>
									<tr v-for="h in blockHistory" v-bind:key="h.history_no">
										<td>
											<span v-if="h.crt_dt">{{ h.crt_dt | moment('MM-DD-YYYY HH:mm:ss') }}</span>
										</td>
										<td>{{ h.crt_user }}</td>
										<td>{{ h.blocked ? h.block_reason : 'Un Blocked' }}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<div v-if="user.company_id == 'beautyplus' && user.admin_yn == 'Y'" v-show="historyTab == 'active'" class="fixed-table-container" style="height: 235px; overflow-x: auto;">
						<div class="table-wrapper">
							<table class="list_tbl tbl_pointer" border="0">
								<thead>
									<tr>
										<th style="text-align:center;width:180px;"><div class="th-text">Date Time</div></th>
										<th style="text-align:center;width:180px;"><div class="th-text">Operator ID</div></th>
										<th style="text-align:center;"><div class="th-text">Active Status</div></th>
									</tr>
								</thead>

								<tbody>
									<tr v-for="h in activeHistory" v-bind:key="h.history_no">
										<td>
											<span v-if="h.crt_dt">{{ h.crt_dt | moment('MM-DD-YYYY HH:mm:ss') }}</span>
										</td>
										<td>{{ h.crt_user }}</td>
										<td>{{ h.active_yn == 'Y' ? 'Active' : 'Inactive' }}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>

				<div class="mgb_5">
					<h4 class="inner_h5">
						<template v-if="arViewable">Invoice with AR Amount</template>
						<template v-else>&nbsp;</template>
					</h4>
					<div class="fixed-table-container" style="height: 235px; overflow-x: auto;">
						<!-- <div class="table-wrapper" style="height:410px;"> -->
						<div v-if="arViewable" class="table-wrapper">
							<table class="list_tbl tbl_pointer" border="0">
								<thead>
									<tr>
										<th style="text-align:center;width:110px;"><div class="th-text">Inv No.</div></th>
										<th style="text-align:center;width:80px;"><div class="th-text">Inv Date</div></th>
										<th style="text-align:center;width:90px;"><div class="th-text">Inv Amt.</div></th>
										<th style="text-align:center;width:90px;"><div class="th-text">AR Amt.</div></th>
										<th style="text-align:center;width:80px;"><div class="th-text">Due Date</div></th>
										<th style="text-align:center;"><div class="th-text">Elapsed Days</div></th>
									</tr>
								</thead>

								<tbody>
									<tr v-for="inv in invoices_with_ar" :key="inv.invoice_no" @click="gotoInvoiceDetail(inv)">
										<td>{{ inv.invoice_dn }}</td>
										<td>{{ inv.invoice_date }}</td>
										<td class="al_right">{{ inv.invoice_amount | toCurrency }}</td>
										<td class="al_right">{{ (inv.balance + inv.post_check_amount) | toCurrency }}</td>
										<td>{{ inv.due_date }}</td>
										<td class="al_right">
											<font v-if="inv.past_due_date > 0" style="color: red;">{{ inv.elapsed_days | commaSeparated }}</font>
											<font v-else>{{ inv.elapsed_days | commaSeparated }}</font>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>

					<div v-if="arViewable">
						<table class="list_tbl tbl_pointer" border="0">
							<thead>
								<tr>
									<th style="text-align:center;width:110px;"><div class="th-text">Inv No.</div></th>
									<th style="text-align:center;width:80px;"><div class="th-text">Inv Date</div></th>
									<th style="text-align:center;width:90px;"><div class="th-text">Inv Amt.</div></th>
									<th style="text-align:center;width:90px;"><div class="th-text">AR Amt.</div></th>
									<th style="text-align:center;width:80px;"><div class="th-text">Due Date</div></th>
									<th style="text-align:center;"><div class="th-text">Elapsed Days</div></th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td colspan="2" class="al_right">TOTAL</td>
									<td class="al_right">{{ totalInvoiceAmt | toCurrency }}</td>
									<td class="al_right">{{ totalArAmt | toCurrency }}</td>
									<td colspan="2"></td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>

				<div>
					<h4 class="inner_h5">
						<template v-if="arViewable">Post-Dated Check</template>
						<template v-else>&nbsp;</template>
					</h4>
					<div class="fixed-table-container" style="height: 235px; overflow-x: auto;">
						<!-- <div class="table-wrapper" style="height:410px;"> -->
						<div v-if="arViewable" class="table-wrapper">
							<table class="list_tbl tbl_pointer" border="0">
								<thead>
									<tr>
										<th style="text-align:center;width:110px;"><div class="th-text">Check No.</div></th>
										<th style="text-align:center;width:80px;"><div class="th-text">Date</div></th>
										<th style="text-align:center;width:90px;"><div class="th-text">Check Amt.</div></th>
										<th style="text-align:center;width:90px;"><div class="th-text">Days</div></th>
										<th style="text-align:center;"><div class="th-text">Invoice(s)</div></th>
									</tr>
								</thead>

								<tbody>
									<tr v-for="ch in post_dated_checks" :key="ch.receipt_item_no">
										<td>{{ ch.check_no }}</td>
										<td>{{ ch.valid_receipt_date }}</td>
										<td class="al_right">{{ ch.ri_amount | toCurrency }}</td>
										<td class="al_right">{{ ch.elapsed_days | commaSeparated }}</td>
										<td>
											<p v-for="inv in ch.invoices" :key="inv.invoice_no" @click="gotoInvoiceDetail(inv)">{{ inv.invoice_dn }}</p>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div style="padding-left:25px;padding-top:20px;padding-bottom:20px;">
			<!-- #3406 : Restriction Only 보기(지정 State 조회 전용)는 같은 보기가 있는 AR History·Sales Order 만 남긴다. -->
			<a href="javascript:;" type="button" class="menu_bt mgr_15" @click="gotoARHistory()">AR History</a>
			<a v-if="!state_scope_read_only" href="javascript:;" type="button" class="menu_bt mgr_15" @click="gotoBackOrder()">Back Order</a>
			<a v-if="!state_scope_read_only" href="javascript:;" type="button" class="menu_bt mgr_15" @click="gotoBestSellItem()">Best Sell Item</a>
			<a v-if="!state_scope_read_only" href="javascript:;" type="button" class="menu_bt mgr_15" @click="gotoCallTag()">Call Tag</a>
			<a v-if="!state_scope_read_only" href="javascript:;" type="button" class="menu_bt mgr_15" @click="gotoInventory()">Inventory</a>
			<a v-if="!state_scope_read_only" href="javascript:;" type="button" class="menu_bt mgr_15" @click="gotoInvoice()">Invoice</a>
			<a v-if="!state_scope_read_only" href="javascript:;" type="button" class="menu_bt mgr_15" @click="gotoItemInquiry()">Item Inquiry</a>
			<a v-if="!state_scope_read_only" href="javascript:;" type="button" class="menu_bt mgr_15" @click="gotoItemList()">Item List</a>
			<a href="javascript:;" type="button" class="menu_bt mgr_15" @click="gotoSalesOrder()">Sales Order</a>
		</div>

		<Modal @close="closeModal" v-if="showModal && modalName == 'GoogleMap'">
			<!-- default 슬롯 콘텐츠 -->
			<template slot="title">Select Location</template>
			<template slot="body">
				<!-- #3406 : 조회 전용이면 지도는 보기만 한다(Select·Close 버튼 없음, 창은 머리글 Close 로 닫는다). -->
				<GoogleMap :initialLocation="location" :viewButton="!state_scope_read_only" v-on:updateLocation="updateLocation" v-on:close="closeModal()" />
			</template>
		</Modal>

		<Modal @close="closeModal" v-if="showModal && modalName == 'Memo'">
			<!-- default 슬롯 콘텐츠 -->
			<template slot="title">Partner Memo</template>
			<template slot="body">
				<MemoPopup :partner_code="partner.code" :read_only="state_scope_read_only" v-on:close="closeModal()" />
			</template>
		</Modal>

		<ShipToAddressManagement v-if="showModal && modalName == 'ShipToAddressManagement'" :modifiable="modifiable" :read_only="state_scope_read_only" :partner_code="partner.code" @close="closeModal()" @updateShipToAddr="closeModal()" />

		<Modal @close="closeModal" v-if="showModal && modalName == 'CheckSOAddress'">
			<!-- default 슬롯 콘텐츠 -->
			<template slot="title">Sales order with different ship address</template>
			<template slot="body">
				<div style="width:1000px; height:600px;" v-on:keyup.esc="close()">
					<table class="list_tbl tbl_pointer">
						<thead>
							<tr>
								<th><input type="checkbox" @change="selectAll()" v-model="allSelected" /></th>
								<th width="110px;">SO No</th>
								<th width="90px;">SO Date</th>
								<th width="100px;">Status</th>
								<th>Address</th>
								<th width="120px;">City</th>
								<th width="80px;">State</th>
								<th width="100px;">Postal Code</th>
								<th width="100px;">Country</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="so in check_sos" v-bind:key="so.invoice_no">
								<td class="al_center"><input type="checkbox" v-model="so.selected" /></td>
								<td class="al_left">{{ so.so_dn }}</td>
								<td class="al_left">{{ so.so_date }}</td>
								<td class="al_left">{{ so.status_code | saleStatusName }}</td>
								<td class="al_left">{{ so.address_detail }} {{ so.address_detail2 }}</td>
								<td class="al_left">{{ so.address_city }}</td>
								<td class="al_left">{{ so.address_state }}</td>
								<td class="al_left">{{ so.address_zipcode }}</td>
								<td class="al_left">{{ so.address_country }}</td>
							</tr>
						</tbody>
					</table>

					<div class="popup_bottom">
						<a href="javascript:;" @click="updateShipAddresses()" class="search_bt mgr_15">Update ship address(es)</a>
						<a href="javascript:;" @click="closeModal()" class="gray_bt">Close</a>
					</div>
				</div>
			</template>
		</Modal>
	</div>
</template>

<script>
import { apiGetThirdPartyCustomersByCode, apiDeleteThirdPartyOrderCustomerById, apiInsertThirdPartyOrderCustomer, apiGetCustomerByThirdPartyCustomerId } from '@/api/shopify/shopify_order.js';
import { apiGetShopifyStoreList } from '@/api/shopify/shopify_common.js';
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiSelectArList, apiSelectArHistory, apiArHistoryIndex } from '@/api/receipt/index.js';
import { isStateScopeBlocked } from '@/api/index';
import {
	apiDetailIndex,
	apiSelectPartner,
	apiCheckPartnerExists,
	apiSelectNewPartnerCode,
	apiInsertPartner,
	apiUpdatePartner,
	apiDeletePartner,
	apiInsertPartnerDocInfo,
	apiDeletePartnerDocInfo,
	apiConfirmAddress,
	apiUpdatePart,
	apiSelectPartnerBlockHistory,
	apiSelectPartnerActiveHistory,
} from '@/api/partner/index.js';
import { apiSelectInvoiceShipmentList, apiUpdateInvoiceShipmentAddressToPartnerAddress } from '@/api/sales/invoice.js';
import { apiDownloadFile, apiUploadFile } from '@/api/util.js';
// import { apiSelectCodeList } from '@/api/basicinfo/code.js';
import CodeSelect from '@/components/common/CodeSelect';
import PartnerSelect from '@/components/common/PartnerSelect';
import Modal from '@/components/common/Modal';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import GoogleMap from '@/components/common/GoogleMap';
import MemoPopup from '@/components/common/MemoPopup';
import ShipToAddressManagement from '@/components/common/ShipToAddressManagement.vue';
import { today, compareDate, dateStrDiff } from '@/utils/date.js';
import _ from 'lodash';

export default {
	data: function() {
		return {
			backUri: '/partner/partner_main',
			mode: 'add',
			partner: {
				partner_type: 'C',
				active_yn: 'Y',
				invoice_date_editable: true,
				show_credit: true,
			},
			docs: [],

			blockHistory: [],
			activeHistory: [],
			historyTab: 'block',

			countries: [],
			businessTypes: [],
			grades: [],
			races: [],
			deliveryTypes: [],
			shipCharges: [],
			salesGroups: [],
			salesmans: [],
			paymentTerms: [],
			recipetTypes: [],
			arTypes: [],
			docTypes: [],
			territories: [],
			doc_type_code: null,
			doc_type_name: null,
			// depts: [],
			// salesTeams: [],

			// userTypes: [
			// 	{ value: 'staff', text: 'Office' },
			// 	{ value: 'salesman', text: 'Salesman' },
			// 	{ value: 'driver', text: 'Driver' },
			// 	{ value: 'whstaff', text: 'Warehouse Staff' },
			// ],

			modalName: '',
			showModal: false,

			currentTabPage: 0,
			tabHeight: 460,

			tabPages: ['General Info.', 'Biz Process Info.', 'Accounting Info.', 'Owner Info.', 'Documents'],

			initial_partner_type: null,

			profile: null,

			invoices_with_ar: [],
			ar_histories: [],
			// #3406 : AR 요청마다 번호를 매겨 마지막으로 보낸 요청의 결과만 화면에 둔다.
			ar_list_seq: 0,
			ar_history_seq: 0,
			// #3406 : Store 를 여는 흐름(init·findPartner) 번호. 새 흐름이 시작되면 이전 흐름은 다음 단계로 가지 않는다.
			partner_flow_seq: 0,
			// #3406 : 코드 검색(존재 확인) 번호. 늦게 온 이전 검색 결과는 버린다.
			partner_lookup_seq: 0,
			// #3406 : URL 의 restriction_only=true(Partner Main 등의 Restriction Only 보기에서 연 상세). 가용 표식(조회자)을 받은 뒤에도 켜져 있을 때만 조회에 플래그를 싣는다.
			restriction_only: false,
			// #3406 : 마지막 상세 응답이 지정 State 의 조회 전용 자료인가. 응답 표식으로만 정한다.
			state_scope_read_only: false,

			search_partner_code: null,

			third_party_store_list: [],
			selected_third_party_store_no: null,
			third_party_customer_ids: [],
			new_program_customer_id: null,

			check_sos: [],
			allSelected: false,
		};
	},
	computed: {
		tabTitle() {
			return this.tabPages[this.currentTabPage];
		},
		location() {
			return {
				lat: this.partner.lat,
				lng: this.partner.lng,
				place_id: this.partner.place_id,
				address_detail: this.partner.address_detail,
				address_city: this.partner.address_city,
				address_state: this.partner.address_state,
				address_zipcode: this.partner.address_zipcode,
				country: this.partner.country,
			};
		},
		user: function() {
			return this.$session.get('user');
		},
		arViewableAuth() {
			let auth = false;
			if (this.user) {
				auth = this.user.admin_yn === 'Y'; // 기본적으로 admin은 볼 수 있게 설정

				if (!auth) {
					if (this.user.company_id === 'beautyplus') auth = this.user.user_id === 'ANNA';
					else if (this.user.company_id === 'newjigu') auth = true;
				}
			}

			return auth;
		},
		arViewable() {
			// #3406 : 지정 State 의 조회 전용 상세에는 내장 AR 패널을 두지 않는다(AR History 의 같은 보기로 본다).
			return this.mode === 'detail' && this.partner.partner_type !== 'V' && this.arViewableAuth && !this.state_scope_read_only;
		},
		modifiable() {
			//console.log(this.mode, this.partner.name);
			if (this.mode == 'detail' && !this.partner.name) return false;
			// #3406 : 지정 State 의 조회 전용 상세는 저장·메모·문서 변경을 열지 않는다.
			if (this.state_scope_read_only) return false;

			var menus = this.$session.get('menus');

			// var current_path = this.$router.history.current.path;
			// console.log('hmmm', current_path);
			// if (this.initial_partner_type == 'C') current_path = current_path.replace('partner', 'customer');
			// else if (this.initial_partner_type == 'V') current_path = current_path.replace('partner', 'vendor');
			// console.log('hmm2', current_path);

			for (var i = 0; i < menus.length; i++) {
				if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				//if ((menus[i].path == current_path || menus[i].path == current_path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		partModifiable() {
			if (this.state_scope_read_only) return false;
			if (this.mode == 'detail' && this.user.company_id == 'newjigu') {
				if (this.user.user_type == 'salesman' || this.user.admin_yn == 'Y') return true;
			}

			return false;
		},
		reformattedSalesmans() {
			return this.salesmans.map(sm => ({ code: sm.user_id, name: sm.name }));
		},
		ar_param() {
			return {
				paging_yn: 'N',
				real_outstanding_yn: 'Y',
				bill_to_code: this.partner.code,
				sort_key: 'invoice_date',
				sort_direction: 'ASC',
				exclude_void: true,
			};
		},
		post_dated_checks() {
			const res = [];
			const makeSimpleInv = el => ({ invoice_no: el.invoice_no, invoice_dn: el.invoice_dn, invoice_type: el.invoice_type });

			this.ar_histories
				.filter(el => el.ar_post_check) // post_check인 경우로 filtering
				.forEach(el => {
					// 화면에 표시될 요소로 배열(res) 구성
					const idx = res.findIndex(r => el.receipt_item_no === r.receipt_item_no);
					if (idx < 0) {
						res.push({
							receipt_item_no: el.receipt_item_no,
							check_no: el.check_no,
							valid_receipt_date: el.valid_receipt_date,
							ri_amount: el.ri_amount,
							invoices: [makeSimpleInv(el)],
							rep_invoice_date: el.invoice_date, // 가장 오래된 Invoice의 invoice_date를 대표값으로 하여 elapsed_days 계산
						});
					} else {
						res[idx].invoices.push(makeSimpleInv(el));
						if (compareDate(res[idx].rep_invoice_date, el.invoice_date) === 1) res[idx].rep_invoice_date = el.invoice_date;
					}
				});

			res.forEach(el => (el.elapsed_days = dateStrDiff(el.rep_invoice_date, el.valid_receipt_date)));

			return res;
		},
		totalInvoiceAmt() {
			return this.invoices_with_ar.reduce((prev, curr) => prev + curr.invoice_amount, 0);
		},
		totalArAmt() {
			return this.invoices_with_ar.reduce((prev, curr) => prev + (curr.balance + curr.post_check_amount), 0);
		},
		shopifyUsable() {
			const menus = this.$session.get('menus');
			let path = '/sales/shopify';
			let idx = menus.findIndex(mn => mn.path === path && mn.view_yn === 'Y' && !mn.hide);
			return idx > -1;
		},
	},
	watch: {
		currentTabPage: {
			immediate: true,
			handler(tab_num) {
				if (this.mode !== 'detail') return;

				const tab_name = this.tabPages[tab_num];
				if (tab_name.toUpperCase().indexOf('SHOPIFY') > -1) {
					this.getShopifyStoreList();
				}
			},
		},
		selected_third_party_store_no: {
			handler(store_no) {
				if (!store_no) {
					this.third_party_customer_ids = [];
				} else {
					this.getThirdPartyCustomersByCode();
				}
			},
		},
	},
	components: {
		GoogleMap,
		MemoPopup,
		Modal,
		CodeSelect,
		CustomDatePicker,
		PartnerSelect,
		ShipToAddressManagement,
	},
	methods: {
		async deleteThirdPartyCustomer(cust_no) {
			if (this.state_scope_read_only) return;
			const { data } = await apiDeleteThirdPartyOrderCustomerById(cust_no);
			if (data.result === 'SUCCESS') {
				this.$toast.success('Delete Third Party Store Cust.');
				this.getThirdPartyCustomersByCode();
			} else this.$toast.error('Failed to Delete Third Party Store Cust.');
		},
		async addThirdPartyCustomer() {
			if (this.state_scope_read_only) return;
			const checkValid = await this.checkValidThirdPartyCustId();
			if (!checkValid) return;

			const { data } = await apiInsertThirdPartyOrderCustomer(this.partner.code, this.new_program_customer_id, this.selected_third_party_store_no);
			if (data.result === 'SUCCESS') {
				this.$toast.success('Success to Add Third Party Store Cust.');
				this.getThirdPartyCustomersByCode();
			} else this.$toast.error('Failed to Add Third Party Store Cust.');
		},
		async checkValidThirdPartyCustId() {
			if (!this.new_program_customer_id) {
				this.$toast.error('Please, Input Cust ID.');
				return false;
			}

			this.new_program_customer_id = 'gid://shopify/Customer/' + this.new_program_customer_id;

			const { data } = await apiGetCustomerByThirdPartyCustomerId(this.selected_third_party_store_no, this.new_program_customer_id);
			if (data && data.cust_no) {
				this.$toast.error('Cust ID Already Exists.');
				return false;
			}

			return true;
		},
		async getShopifyStoreList() {
			const { data } = await apiGetShopifyStoreList();
			this.third_party_store_list = data || [];
			if (this.third_party_store_list.length > 0) this.selected_third_party_store_no = this.third_party_store_list[0].store_no;
		},
		async getThirdPartyCustomersByCode() {
			const { data } = await apiGetThirdPartyCustomersByCode(this.partner.code, this.selected_third_party_store_no);
			this.third_party_customer_ids = data || [];
		},
		async updatePart() {
			if (this.state_scope_read_only) return;
			const { data } = await apiUpdatePart(this.partner);

			if (data.result) {
				this.$toast.success('Only Updatable Info(Business Type, Description, Owner Info, Contact Information Except Telephone 1) Saved Successfully');
			} else {
				this.$toast.error(data.msg);
			}
		},

		async findPartner() {
			if (!this.search_partner_code) {
				this.$toast.error('Empty search string');
				return;
			}

			// #3406 : 검색 확인은 따로 번호를 매긴다. 없는 코드 검색이 진행 중인 Store 흐름을 끊으면
			// Code 만 바뀌고 나머지 칸은 이전 Store 인 화면이 남는다.
			const lookup = ++this.partner_lookup_seq;
			const { data } = await apiSelectPartner(
				this.partnerRequest({
					code: this.search_partner_code,
					partner_code: this.search_partner_code,
				}),
			);
			if (lookup !== this.partner_lookup_seq || this.is_destroyed) return;

			if (!data.partner) {
				this.$toast.error('Partner information not found.');
				return;
			}

			// 코드가 확인된 뒤에만 새 흐름을 연다.
			const flow = this.startPartnerFlow();
			// #3406 : Restriction Only 보기에서는 Code 만 바뀐 동안(새 Store 의 자료·잠금이 오기 전) 이전 Store 의 잠금 상태로
			// 저장·업로드하지 못하게 먼저 잠근다. 새 응답의 표식이 최종 잠금을 정한다.
			if (this.restriction_only) {
				this.state_scope_read_only = true;
				// 이전 Store 의 자료로 연 창(Memo·배송지 관리 등)도 닫는다. 열린 채 잠금이 바뀌면 이전 Store 의 메모가 새 잠금으로 보인다.
				this.showModal = false;
			}
			this.partner.code = this.search_partner_code;
			this.search_partner_code = null;

			await this.selectPartner(flow);
			if (!this.isCurrentPartnerFlow(flow)) return;
			// #3406 : 지정 State 의 조회 전용 Store 는 내장 AR 을 부르지 않는다.
			if (this.state_scope_read_only) return;
			await this.selectArList();
			if (!this.isCurrentPartnerFlow(flow)) return;
			await this.selectArHistory();
		},
		// #3406 : 더 새 흐름이 시작됐거나 화면을 떠났으면 false. 떠난 화면이 새로 보내는 요청은
		// 이동한 뒤의 화면 세대로 찍혀 걸러지지 않으므로, 여기서 아예 보내지 않는다.
		isCurrentPartnerFlow(flow) {
			return flow === this.partner_flow_seq && !this.is_destroyed;
		},
		// #3406 : Partner 조회 본문. Restriction Only 보기에서 연 상세에서만 boolean 플래그를 싣는다(그 밖에는 종전 본문 그대로).
		partnerRequest(param) {
			if (this.restriction_only) param.restriction_only = true;
			return param;
		},
		// #3406 : 새 흐름을 연다. 이전 흐름이 보낸 AR 요청의 응답도 무효로 만들어, 새 Store 의 AR 이 오기 전에
		// 이전 Store 의 AR 이 잠깐이라도 새 Store 아래 보이지 않게 한다.
		startPartnerFlow() {
			this.ar_list_seq += 1;
			this.ar_history_seq += 1;
			this.partner_flow_seq += 1;
			return this.partner_flow_seq;
		},
		async confirmAddress() {
			if (!(this.partner && this.partner.address_detail && this.partner.address_city && this.partner.address_state)) {
				this.$toast.error('Please, Input Address, City and State.');
				return;
			}

			if (!(this.partner && ['US', 'USA'].includes(this.partner.country))) {
				this.$toast.error('Confirming Address is Only Served<br />When the Address is in USA.');
				return;
			}

			const { data } = await apiConfirmAddress(this.partner.address_detail, this.partner.address_city, this.partner.address_state);

			// response data가 null인 경우
			if (!data) {
				this.$toast.error('Address API Error.');
				return;
			}

			// response data에 error가 있는 경우
			if (data.error) {
				this.$toast.error(data.error.message);
				return;
			}

			// zipcode 비교: zipcode가 다르게 입력된 경우 Alert
			if (!data.address) {
				this.$toast.error('No Address Info.');
				return;
			}

			const addr_res = data.address;
			const dash_idx = this.partner.address_zipcode.indexOf('-');

			let is_equals = false;

			if (dash_idx > -1 && addr_res.ZIPPlus4) {
				if (this.partner.address_zipcode === addr_res.ZIPCode + '-' + addr_res.ZIPPlus4) is_equals = true;
			} else {
				if (this.partner.address_zipcode === addr_res.ZIPCode) is_equals = true;
			}

			if (is_equals) this.$toast.success('Valid Address.');
			else this.$alertify.alert('Alert', 'Suggested Zip Code: ' + addr_res.ZIPCode + (addr_res.ZIPPlus4 ? '-' + addr_res.ZIPPlus4 : ''));
		},
		gotoBackOrder() {
			let routeData = this.$router.resolve({
				name: 'backOrder',
				query: {
					backUri: this.uri,
					ship_to_code: this.partner.code,
				},
			});
			window.open(routeData.href, 'herp_backorder');
		},
		gotoBestSellItem() {
			this.$alertify.alert('Alert', 'Under Deveopment');
		},
		gotoSalesOrder() {
			const query = {
				backUri: this.uri,
				ship_to_code: this.partner.code,
				so_date_from: 'NON_SELECT',
				so_date_to: 'NON_SELECT',
			};
			// #3406 : 지정 State 의 조회 전용 Store 는 SO Main 도 Restriction Only 보기로 연다.
			if (this.state_scope_read_only) query.restriction_only = 'true';
			let routeData = this.$router.resolve({
				name: 'soMain',
				query: query,
			});
			window.open(routeData.href, 'herp_so');
		},
		gotoInventory() {
			let routeData = this.$router.resolve({
				name: 'inventoryStatus',
				query: {
					backUri: this.uri,
				},
			});
			window.open(routeData.href, 'herp_inventory');
		},
		gotoItemList() {
			let routeData = this.$router.resolve({
				name: 'salesGoods',
				query: {
					backUri: this.uri,
					date_from: 'NON_SELECT',
					date_to: 'NON_SELECT',
					ship_tos_string: this.partner.code,
				},
			});
			window.open(routeData.href, 'herp_item');
		},
		gotoItemInquiry() {
			let routeData = this.$router.resolve({
				name: 'itemInquiry',
				query: {
					backUri: this.uri,
					partner_code: this.partner.code,
				},
			});
			window.open(routeData.href, 'herp_item_inquiry');
		},
		gotoInvoiceDetail(invoice) {
			const invoice_no = invoice.invoice_no;
			const invoice_type = invoice.invoice_type;
			if (!['S', 'R'].includes(invoice_type)) return; // 'A', 'B'타입 Invoice에 대한 상세화면 페이지는 없음.

			let routeData = this.$router.resolve({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { invoice_no: invoice_no } });
			window.open(routeData.href, '_blank');
		},
		gotoInvoice() {
			let routeData = this.$router.resolve({
				name: 'invoiceMain',
				query: {
					backUri: this.uri,
					bill_to_code: this.partner.code,
					invoice_date_from: 'NON_SELECT',
					invoice_date_to: 'NON_SELECT',
				},
			});
			window.open(routeData.href, 'herp_invoice');
		},
		gotoARHistory() {
			const query = {
				backUri: this.uri,
				bill_to_code: this.partner.code,
				bill_to_name: this.partner.name,
				date_type_is_invoice: '1',
			};
			// #3406 : 지정 State 의 조회 전용 Store 는 A/R History 도 Restriction Only 보기로 연다.
			if (this.state_scope_read_only) query.restriction_only = 'true';
			let routeData = this.$router.resolve({
				name: 'arHistory',
				query: query,
			});
			window.open(routeData.href, 'herp_ar_history');
		},
		gotoCallTag() {
			let routeData = this.$router.resolve({
				name: 'callTag',
				query: {
					backUri: this.uri,
					ship_to_code: this.partner.code,
				},
			});
			window.open(routeData.href, 'herp_calltag');
		},
		blockStatusChanged() {
			//console.log(partner.blocked);
			if (!this.partner.blocked) this.partner.block_reason = null;
		},
		goBack() {
			window.history.go(-1);
		},
		clearAddress() {
			this.partner.address_detail = '';
			this.partner.address_detail2 = '';
			this.partner.address_city = '';
			this.partner.address_state = '';
			this.partner.address_zipcode = '';
			this.partner.country = '';
		},
		clearOwnerAddress() {
			this.partner.owner_address_detail = '';
			this.partner.owner_address_city = '';
			this.partner.owner_address_state = '';
			this.partner.owner_address_zipcode = '';
			this.partner.owner_country = '';
		},
		updateLocation: function(location) {
			// #3406 : 조회 전용(또는 새 Store 를 여는 중의 잠금)이면 위치·주소를 바꾸지 않는다.
			if (this.state_scope_read_only) return;
			if (location.lat) this.partner.lat = location.lat;
			if (location.lng) this.partner.lng = location.lng;
			if (location.place_id) this.partner.place_id = location.place_id;
			if (location.address_detail && !this.partner.address_detail) this.partner.address_detail = location.address_detail;
			if (location.address_city && !this.partner.address_city) this.partner.address_city = location.address_city;
			if (location.address_state && !this.partner.address_state) this.partner.address_state = location.address_state;
			if (location.address_zipcode && !this.partner.address_zipcode) this.partner.address_zipcode = location.address_zipcode;
			if (location.country && !this.partner.country) this.partner.country = location.country;

			//console.log(location);
			//this.user.place_id = placeId;
			//console.log('event received');
			//console.log(this.user);
		},
		selectTab(selectedTabPage) {
			this.currentTabPage = selectedTabPage;
		},
		// #3406 : State 제한 사용자는 AR 조회가 막혀도 Store 화면을 그대로 쓴다. 막히면 비우고,
		// AR 을 볼 수 없는 사용자에게는 안내도 띄우지 않는다. 그 밖의 오류는 종전대로 오류 화면으로 간다.
		arRequestConfig() {
			return { stateScopeOptional: true, stateScopeSilent: !this.arViewable };
		},
		async selectArHistory() {
			const seq = ++this.ar_history_seq;
			try {
				const { data } = await apiSelectArHistory(this.ar_param, this.arRequestConfig());
				if (seq === this.ar_history_seq) this.ar_histories = data.arHistory;
			} catch (e) {
				if (!isStateScopeBlocked(e)) throw e;
				if (seq === this.ar_history_seq) this.ar_histories = [];
			}
		},
		async selectArList() {
			const seq = ++this.ar_list_seq;
			try {
				const { data } = await apiSelectArList(this.ar_param, this.arRequestConfig());
				if (seq === this.ar_list_seq) this.invoices_with_ar = data.arList;
			} catch (e) {
				if (!isStateScopeBlocked(e)) throw e;
				if (seq === this.ar_list_seq) this.invoices_with_ar = [];
			}
		},
		async selectPartner(flow) {
			const { data } = await apiSelectPartner(
				this.partnerRequest({
					code: this.partner.code,
					partner_code: this.partner.code,
					include_specialty: true,
				}),
			);
			// #3406 : 더 새 흐름이 시작됐으면 이 결과로 화면을 덮지 않는다. 덮으면 Store 와 AR 이 서로 다른 흐름의 것이 된다.
			if (flow !== undefined && !this.isCurrentPartnerFlow(flow)) return;

			if (!data.partner) {
				this.$toast.error('Partner information not found. You may have no permission.');
				return;
			}

			// #3406 : 조회 전용 여부는 이 응답의 표식으로 정하고 자료와 같은 tick 에 바꾼다. 표식이 없으면 푼다.
			this.state_scope_read_only = !!data.state_scope_read_only;
			this.partner = data.partner;
			this.docs = data.docList;
			this.blockHistory = data.blockHistory;
			this.activeHistory = data.activeHistory || [];

			if (this.partner.blocked && !this.$partnerBlockReasons.includes(this.partner.block_reason)) {
				this.partner.other_block_reason = this.partner.block_reason;
				this.partner.block_reason = 'OTHER';
			}
			//console.log(this.blockHistory);

			this.check_sos = [];

			if (this.partner.ytd == null) this.partner.ytd = 0;
			//console.log(this.blockHistory);
			//console.log(this.partner);
			//console.log(this.docs);

			this.selectTab(this.currentTabPage);
		},
		setBusinessType(code) {
			if (code) this.partner.business_type_name = code.name;
			else this.partner.business_type_name = '';
		},
		setGrade(code) {
			if (code) this.partner.grade_name = code.name;
			else this.partner.grade_name = '';
		},
		setRace(code) {
			if (code) this.partner.race_name = code.name;
			else this.partner.race_name = '';
		},
		setTerritory(code) {
			if (code) this.partner.territory_name = code.name;
			else this.partner.territory_name = '';
		},
		setDeliveryType(code) {
			if (code) this.partner.delivery_type_name = code.name;
			else this.partner.delivery_type_name = '';

			if (this.partner.delivery_type_name.toUpperCase().startsWith('PICKUP')) {
				this.partner.cod_free_yn = 'Y';
				this.partner.handling_charge_free_yn = 'Y';
			}
		},
		setShipCharge(code) {
			if (code) this.partner.ship_charge_name = code.name;
			else this.partner.ship_charge_name = '';
		},
		setSalesGroup(code) {
			if (code) this.partner.sales_group_name = code.name;
			else this.partner.sales_group_name = '';
		},
		setSalesman(user) {
			if (user) this.partner.salesman_name = user.name;
			else this.partner.salesman_name = '';
		},
		setPaymentTerm(code) {
			if (code) this.partner.payment_term_name = code.name;
			else this.partner.payment_term_name = '';
		},
		setReceiptType(code) {
			if (code) this.partner.receipt_type_name = code.name;
			else this.partner.receipt_type_name = '';
		},
		setArType(code) {
			if (code) this.partner.ar_type_name = code.name;
			else this.partner.ar_type_name = '';
		},
		setDocType(code) {
			if (code) this.doc_type_name = code.name;
			else this.doc_type_name = '';
		},

		async deleteFile(doc) {
			//console.log(doc);
			if (this.state_scope_read_only) return;
			if (confirm('Are you sure to delete the file?')) {
				const { data } = await apiDeletePartnerDocInfo(doc);
				if (data.result) {
					this.$toast.success('File deleted successfully');
					const idx = this.docs.findIndex(function(item) {
						return item.doc_no === doc.doc_no;
					});
					this.docs.splice(idx, 1);
				}
			}
		},
		async uploadFile() {
			const elem = this.$refs.uploadFile;
			elem.click();
		},
		async uploadFileConfirm() {
			// #3406 : 조회 전용(또는 새 Store 를 여는 중의 잠금)이면 올리지 않는다.
			if (this.state_scope_read_only) return;
			// #3406 : 올리는 동안 다른 Store(지정 State 의 조회 전용 Store 일 수 있다)로 바뀌어도 문서는 올리기 시작한 Store 에 붙인다.
			const partner_code = this.partner.code;
			const flow = this.partner_flow_seq;
			var file = this.$refs.uploadFile.files[0];
			var response = await apiUploadFile(file);
			if (response.data.result) {
				var newFilename = response.data.filename;
				//this.$toast.success('File uploaded successfully');
				var newDoc = {
					partner_code: partner_code,
					doc_type_code: this.doc_type_code,
					doc_type_name: this.doc_type_name,
					original_filename: file.name,
					filename: newFilename,
					filesize: file.size,
				};
				response = await apiInsertPartnerDocInfo(newDoc);
				if (response.data.result) {
					this.$toast.success('File uploaded successfully');

					newDoc.doc_no = response.data.doc_no;
					//console.log(newDoc);
					// #3406 : 그 사이 다른 Store 를 열었으면 그 Store 의 문서 목록에 넣지 않는다.
					if (flow === this.partner_flow_seq) this.docs.push(newDoc);

					this.$refs.uploadFile.value = null;
				}
			}
		},
		async downloadFile(doc) {
			//console.log(filename);
			if (this.state_scope_read_only) return;
			await apiDownloadFile(doc.filename, doc.original_filename);
		},
		async checkExists() {
			const { data } = await apiCheckPartnerExists(this.partner);
			return data.result;
		},
		async checkNameExists() {
			const { data } = await apiCheckPartnerExists({ comparison: 'name', name: this.partner.name });
			return data.result;
		},
		async submit(stay) {
			//console.log('hmmm');
			// #3406 : 조회 전용(또는 새 Store 를 여는 중의 잠금)이면 저장하지 않는다.
			if (this.state_scope_read_only) return;
			if (!this.partner.code) {
				this.$toast.error('Empty Code');
				return;
			}

			if (!this.partner.name) {
				this.$toast.error('Empty Name');
				return;
			}

			if (!this.partner.grade_code) {
				this.$toast.error('Empty Grade');
				return;
			}

			//console.log(this.partner);

			let partner_to_save = _.cloneDeep(this.partner);
			if (partner_to_save.blocked && partner_to_save.block_reason == 'OTHER' && partner_to_save.other_block_reason) {
				partner_to_save.block_reason = partner_to_save.other_block_reason;
			}

			var response;
			if (this.mode == 'add') {
				if (await this.checkExists()) {
					this.$toast.error('Duplicate Code');
					return;
				}
				response = await apiInsertPartner(partner_to_save);
			} else {
				response = await apiUpdatePartner(partner_to_save);
			}
			var data = response.data;

			if (data.result) {
				this.$toast.success('Saved successfully');
				if (this.mode == 'detail') {
					this.check_sos = await this.checkSOAddress();

					if (this.check_sos.length > 0) {
						stay = true;
						this.allSelected = false;
						this.modalName = 'CheckSOAddress';
						this.showModal = true;
					}

					await this.selectPartnerBlockHistory();
					await this.selectPartnerActiveHistory();
				}
				this.mode = 'detail';
				this.$store.commit('setSubTitle', 'Partner -> Detail');
				//console.log(this.backUri);
				if (!stay) this.goBack();
			} else {
				this.$toast.error(data.msg);
			}
		},
		async checkSOAddress() {
			const { data } = await apiSelectInvoiceShipmentList({
				before_shipping_only: true,
				different_address: true,
				ship_to_code: this.partner.code,
			});
			//console.log(data);

			return data.shipmentList;

			//if (data && data.shipmentList.length > 0) {
			// 	if (confirm("The customer's sales order for the most recent week exists. Would you like to check Sales Order?")) this.gotoSalesOrder();
			//}
		},
		async selectPartnerBlockHistory() {
			const { data } = await apiSelectPartnerBlockHistory({ code: this.partner.code });
			this.blockHistory = data.blockHistory;
		},
		async selectPartnerActiveHistory() {
			const { data } = await apiSelectPartnerActiveHistory({ code: this.partner.code });
			this.activeHistory = data.activeHistory || [];
		},
		selectAll() {
			var vm = this;
			this.check_sos.forEach(function(item) {
				item.selected = vm.allSelected;
			});
		},
		async updateShipAddresses() {
			// #3406 : 조회 전용(또는 새 Store 를 여는 중의 잠금)이면 SO 주소를 바꾸지 않는다.
			if (this.state_scope_read_only) return;
			const sos = this.check_sos.filter(s => s.selected);
			if (sos.length == 0) {
				this.$toast.error('Nothing to save');
				return;
			}

			const { data } = await apiUpdateInvoiceShipmentAddressToPartnerAddress({ sos: sos });

			if (data.result) {
				this.$toast.success('Updated successfully');
				this.closeModal();
			} else {
				this.$toast.error('Failed');
			}
			//console.log(this.check_sos.filter(s => s.selected));
		},
		async delUser() {
			if (!this.isErasable) return;
			if (confirm('Are you sure to delete the partner?')) {
				const { data } = await apiDeletePartner(this.partner);

				if (data.result) {
					this.$toast.success('Deleted successfully');
					this.goBack();
				} else {
					this.$toast.error('Failed');
				}
			}
		},
		openModal(modalName) {
			this.modalName = modalName;
			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
		},
		async checkDup() {
			if (await this.checkExists()) {
				this.$toast.error('Duplicate Code');
			} else {
				this.$toast.success('Not Duplicate');
			}
		},
		async checkDupName() {
			if (await this.checkNameExists()) {
				this.$toast.error('Duplicate Name');
			} else {
				this.$toast.success('Not Duplicate');
			}
		},
		makePassword() {
			if (this.mode === 'add') {
				let code = this.partner.code;
				let zipcode = this.partner.address_zipcode;
				if (!_.isEmpty(code)) {
					let first = code.slice(0, 1);
					let other = _.isEmpty(zipcode) ? '00000' : zipcode;
					this.partner.password = first + other;
				}
			}
		},
		setDefaultCountry() {
			let res = this.$session.get('company').ship_address_country;
			// ship_address_country가 유효하지 않은 경우, 미국으로 Default Set
			if (!this.isValidCountryCode(res)) {
				if (this.isValidCountryCode('US')) res = 'US';
				else if (this.isValidCountryCode('USA')) res = 'USA';
			}

			this.partner.country = res;
			this.partner.owner_country = res;
		},
		isValidCountryCode(code) {
			return this.countries.findIndex(c => c.code === code) > -1;
		},
		addTabPages() {
			let idx = -1;

			const tab_name = 'Shopify Info.';
			idx = this.tabPages.indexOf(tab_name);
			if (this.shopifyUsable && this.partner.partner_type !== 'V') {
				if (idx < 0) this.tabPages.push(tab_name);
			} else {
				if (idx > -1) {
					this.tabPages.splice(idx, 1);
					this.currentTabPage = 0;
				}
			}
		},
		async index() {
			const { data } = await apiDetailIndex();

			this.countries = data.countryList;
			this.businessTypes = data.businessTypeList;
			this.grades = data.gradeList;
			this.races = data.raceList;
			this.deliveryTypes = data.deliveryTypeList;
			this.shipCharges = data.shipChargeList;
			this.salesGroups = data.salesGroupList;
			this.salesmans = data.salesmanList;
			this.paymentTerms = data.paymentTermList;
			this.recipetTypes = data.receiptTypeList;
			this.arTypes = data.arTypeList;
			this.docTypes = data.docTypeList;
			this.territories = data.territoryList;
			//console.log(this.territories);

			// Default Country Set
			if (this.mode === 'add') this.setDefaultCountry();
		},
		// #3406 : 조회자인지는 A/R History 와 같은 가벼운 가용 표식 API 로 묻는다(beautyplus 세션만). 표식이 없거나 실패하면
		// 플래그를 끈다(잠금은 첫 상세 응답의 표식이 정한다).
		async loadRestrictionOnlyAvailability() {
			let available = false;
			if (!this.user || this.user.company_id !== 'beautyplus') {
				this.restriction_only = false;
				return;
			}
			try {
				const { data } = await apiArHistoryIndex();
				available = !!data.restriction_only_available;
			} catch (e) {
				available = false;
			}
			if (!available) this.restriction_only = false;
		},
		async setNewCustomerCode() {
			const { data } = await apiSelectNewPartnerCode();
			this.partner.code = data.new_customer_code;
			//console.log(data);
			// if (data.result) {
			// 	this.$toast.success('File deleted successfully');
			// 	const idx = this.docs.findIndex(function(item) {
			// 		return item.doc_no === doc.doc_no;
			// 	});
			// 	this.docs.splice(idx, 1);
			// }
		},
		async init() {
			// #3406 : 첫 조회 중에 사용자가 다른 Store 를 찾아 열면 그 흐름이 이긴다.
			const flow = this.startPartnerFlow();
			await this.index();
			if (this.mode == 'detail') {
				// #3406 : 비조회자가 플래그 URL 을 열어도 상세 요청은 종전과 같아야 한다. 첫 조회 전에 가용 표식을 확인한다.
				if (this.restriction_only) await this.loadRestrictionOnlyAvailability();
				if (!this.isCurrentPartnerFlow(flow)) return;
				await this.selectPartner(flow);
				if (!this.isCurrentPartnerFlow(flow)) return;
				// #3406 : 지정 State 의 조회 전용 Store 는 내장 AR 을 부르지 않는다.
				if (this.state_scope_read_only) return;
				await this.selectArList();
				if (!this.isCurrentPartnerFlow(flow)) return;
				await this.selectArHistory();
			} else {
				this.partner.open_date = today();
			}
		},
	},
	created() {
		this.backUri = this.$route.query.backUri;
		this.mode = this.$route.params.mode;
		this.initial_partner_type = this.$route.params.initial_partner_type;

		this.profile = this.$session.get('profile');

		this.$store.commit('setSideIndex', 8);
		this.$store.commit('setSelectedMenu', 'nav_li_partner_main');
		if (this.mode == 'add') {
			this.$store.commit('setSubTitle', 'Partner -> Add');
			if (this.initial_partner_type) this.partner.partner_type = this.initial_partner_type;
			//console.log(this.profile.show_credit);
			if (this.profile.default_show_credit == 'N') this.partner.show_credit = false;

			if (this.user.company_id == 'beautyplus' || this.user.company_id == 'hairplus') this.partner.notice = 'OPEN ON ' + today('/');

			if (this.initial_partner_type == 'C') this.setNewCustomerCode();
		} else {
			this.$store.commit('setSubTitle', 'Partner -> Detail');
			this.partner.code = this.$route.query.code;
			// #3406 : Restriction Only 보기에서 연 상세. 첫 응답의 표식이 올 때까지 잠가 둔다(기존 범위로 찾으면 풀린다).
			if (this.$route.query.restriction_only === 'true') {
				this.restriction_only = true;
				this.state_scope_read_only = true;
			}
		}

		this.addTabPages();
		//console.log(this.profile);
		this.init();
		//console.log(this.backUri);

		// this.selectDepts();
		// this.selectSalesTeams();
	},
	mounted() {
		inputSelectOnClick();
	},
	beforeDestroy() {
		// #3406 : 반응형일 필요가 없어 data 에 두지 않는다.
		this.is_destroyed = true;
	},
};
</script>

<style>
.menu_bt {
	background: #806128;
	color: #fff;
	line-height: 50px;
	height: 50px;
	width: 110px;
	display: inline-block;
	padding: 18 18px;
	vertical-align: center;
	text-align: center;
	font-size: 14px;
	font-weight: bold;
}
.menu_bt:hover {
	background: #868826;
}
</style>
